import { createSlice } from '@reduxjs/toolkit';

const initialState: string | null = null;

const searchReducerSlice = createSlice({
	name: 'searchReducer',
	initialState,
	reducers: {
		setSearch(state: string | null, action) {
			state = action.payload;
			return action.payload;
		},
		resetSearch(state: string | null, action) {
			return initialState;
		},
	},
});

export const { setSearch, resetSearch } = searchReducerSlice.actions;
export default searchReducerSlice.reducer;
